import { Container } from 'semantic-ui-react'
import { observer } from 'mobx-react-lite';
import { User } from '../../../app/models/user';

interface Props {
    user: User
}

export default observer(function PermitHolderContainerContent({ user }: Props) {
    return (
        <Container className='clear-both'>
            {`${user.subscriberNameFirst} ${user.subscriberNameLast}`}<br /> 
            {user.address} {user.address2 !== '' && user.address2}<br />
            {`${user.city}, ${user.state} ${user.zipCode}`}<br />
            {user.subscriberPhone}<br />
            {user.subscriberEmail}<br />
        </Container>
    )
})